// @flow
import { httpClient } from 'angieslist-app-platform';
import type { EventRequestV1, SendAppLinkRequestV1  } from 'office-home-gateway'; // eslint-disable-line

export const sendOfficeEvent = (event: EventRequestV1): any =>
  httpClient.post(
    '/gateway/office-home/v1/events',
    {
      body: event,
    },
  );

export const sendAppLink = (requestBody: SendAppLinkRequestV1): any =>
  httpClient.post(
    '/gateway/office-home/v1/events/app_link',
    {
      body: requestBody,
    },
  );

export default { sendOfficeEvent, sendAppLink };



// WEBPACK FOOTER //
// ./src/app/common/eventService.js